import React from 'react';
import styled from 'styled-components';
import { MQ_FOR_TABLET_LANDSCAPE_UP } from 'web-ui-kit/media';
import { BodySmallBoldSmallStyles, BodySmallBoldLargeStyles } from 'web-ui-kit/typography';
import UnsegmentedControlWithImageOnly from 'web-ui-kit/SelectionControls/UnsegmentedControlWithImageOnly';
import UnsegmentedControl from 'web-ui-kit/SelectionControls/UnsegmentedControl';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function Variants(_ref) {
  var _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$productDetailsSt = _ref.productDetailsState,
      productDetailsState = _ref$productDetailsSt === void 0 ? {} : _ref$productDetailsSt;
  var variants = productDetailsState.variants,
      variantsLoading = productDetailsState.variantsLoading,
      variantsState = productDetailsState.variantsState; // Early exit if there is nothing to render.

  if (variantsLoading || !variants || variants.colorVariants.length === 0) {
    return null;
  }

  var handleColorClick = function handleColorClick(event) {
    dispatch({
      type: 'pd-color-button-clicked',
      payload: event.payload
    });
  };

  var handleDimsClick = function handleDimsClick(productId) {
    return function (_ref2) {
      var type = _ref2.type,
          payload = _ref2.payload;
      dispatch({
        type: type,
        payload: _objectSpread2({
          productId: productId
        }, payload)
      });
    };
  };

  var colorVariants = variants.colorVariants;
  var Container = styles.Container;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": "variants"
    }, renderColors({
      colorVariants: colorVariants,
      handleColorClick: handleColorClick,
      variantsState: variantsState
    }), renderDimsTable({
      colorVariants: colorVariants,
      handleDimsClick: handleDimsClick,
      variantsState: variantsState
    }))
  );
}
/**
 * Helpers
 */


function renderColors(_ref3) {
  var colorVariants = _ref3.colorVariants,
      handleColorClick = _ref3.handleColorClick,
      variantsState = _ref3.variantsState; // We do not want to render single colors.

  if (colorVariants.length <= 1) {
    return null;
  }

  var ColorThumbsContainer = styles.ColorThumbsContainer,
      ColorThumbsGrid = styles.ColorThumbsGrid,
      Heading = styles.Heading;
  return (
    /*#__PURE__*/
    React.createElement(ColorThumbsContainer, null,
    /*#__PURE__*/
    React.createElement(Heading, null, "Color: ".concat(variantsState.color)),
    /*#__PURE__*/
    React.createElement(ColorThumbsGrid, null, colorVariants.map(function (variantGroup) {
      var color = variantGroup.color,
          dimsTable = variantGroup.dimsTable; // The representative image for this color group is
      // the first image in the group.

      var _ref4 = dimsTable.find(function (dim) {
        return dim.image;
      }) || {},
          _ref4$image = _ref4.image,
          image = _ref4$image === void 0 ? '' : _ref4$image;

      return (
        /*#__PURE__*/
        React.createElement(UnsegmentedControlWithImageOnly, {
          key: color,
          aspectRatio: 1,
          dispatch: handleColorClick,
          id: "yo",
          imgixProps: {
            alt: color,
            bucketName: 'modsy',
            height: 128,
            src: image,
            width: 128
          },
          name: color,
          status: color === variantsState.color ? 'selected' : 'unselected'
        })
      );
    })))
  );
}

var DISABLED_STATUS = ['DISCONTINUED', 'OUT_OF_STOCK'];

function renderDimsTable(_ref5) {
  var colorVariants = _ref5.colorVariants,
      handleDimsClick = _ref5.handleDimsClick,
      variantsState = _ref5.variantsState;
  var activeGroup = colorVariants.find(function (_ref6) {
    var color = _ref6.color;
    return color === variantsState.color;
  });

  if (!activeGroup) {
    return null;
  }

  var dimsTable = activeGroup.dimsTable;
  var DimsContainer = styles.DimsContainer,
      DimsGrid = styles.DimsGrid,
      Heading = styles.Heading;
  return (
    /*#__PURE__*/
    React.createElement(DimsContainer, null,
    /*#__PURE__*/
    React.createElement(Heading, null, "Size: ".concat(variantsState.dimensions)),
    /*#__PURE__*/
    React.createElement(DimsGrid, null, dimsTable.map(function (_ref7) {
      var availabilityStatus = _ref7.availabilityStatus,
          dimensions = _ref7.dimensions,
          productId = _ref7.productId;
      var disabled = !availabilityStatus || DISABLED_STATUS.includes(availabilityStatus);
      return (
        /*#__PURE__*/
        React.createElement(UnsegmentedControl, {
          key: dimensions,
          disabled: disabled,
          dispatch: handleDimsClick(productId),
          height: "2.5rem",
          id: "pd-dims",
          labelText: dimensions,
          selected: dimensions === variantsState.dimensions
        })
      );
    })))
  );
}
/**
 * Styles
 */


var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding: 1rem 1rem 0 1rem;\n\n    ", " {\n      padding: 1.5rem 0 0 0;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  ColorThumbsContainer: styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n  "]))),
  ColorThumbsGrid: styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    grid-gap: 0.5rem;\n    margin-bottom: 1.5rem;\n\n    ", " {\n      grid-template-columns: repeat(8, 1fr);\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  Heading: styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.5rem;\n\n    ", " {\n      ", ";\n      margin-bottom: 0.5rem;\n    }\n  "])), BodySmallBoldSmallStyles, MQ_FOR_TABLET_LANDSCAPE_UP, BodySmallBoldLargeStyles),
  DimsContainer: styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n  "]))),
  DimsGrid: styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-column-gap: 0.5rem;\n    grid-row-gap: 0.5rem;\n\n    ", " {\n      grid-template-columns: 1fr 1fr 1fr;\n        grid-column-gap: 0.75rem;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP)
};
export default Variants;